module.exports = "//static.hsappstatic.net/LearningCenterUI/static-1.8514/images/logo-upwork@2x.png"